// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pp-0";